import MainLayout from "screens/partials/layout";
import AddProductComponent from "screens/partials/add-product";

export default function AddProduct() {
  return (
      <MainLayout>
        <AddProductComponent />
      </MainLayout>
  )
}